import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

import { ToastProvider, useToast } from '@zillow/constellation-10';

import { useIsWizardView } from '../../hooks/useIsWizardView';
import { toastRecipe } from './styles';

export const ToastRenderer = () => {
  const context = useToast();
  const router = useRouter();
  const isWizardView = useIsWizardView();

  const lastPathRef = useRef(router.asPath);

  useEffect(() => {
    // When the route changes, clear all toasts
    if (lastPathRef.current !== router.asPath) {
      context.dismissAll();
      lastPathRef.current = router.asPath;
    }
  }, [router.asPath, context]);

  return (
    <ToastProvider.List
      css={{ marginRight: '0' }} // margin is handled by toastRecipe
      renderToast={(toast) => (
        <ToastProvider.Item key={toast.id} toast={toast} css={toastRecipe.raw({ isWizardView })} />
      )}
    />
  );
};
